<template>
  <div
    v-if="displayedMessages.length"
    class="border-b border-gray-200 pb-4 mb-4"
  >
    <div
      v-for="message in displayedMessages"
      :key="message.id"
      class="flex gap-4 items-start py-3"
    >
      <div class="size-[50px]">
        <UserMessageAvatar :user-id="message.from.id" />
      </div>

      <!-- message content -->
      <div>
        <!-- message header -->
        <div class="flex items-center gap-2">
          <div class="font-bold">{{ message.from.name }}</div>
          <div class="text-xs text-gray-500">{{ displayDate(new Date(message.createdAt).getTime()/1000) }}</div>
        </div>

        <!-- message text -->
        <div>{{ message.text }}</div>

        <!-- attachments -->
        <LightBox :attachments="message.attachments" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Message } from '@/models/message'
import { filter, sortBy } from 'underscore'
import UserMessageAvatar from '@/components/UserMessageAvatar.vue'
import { computed } from 'vue'
import { displayDate } from '@/utils'
import LightBox from '@/components/app/AppLightBox.vue'

const props = defineProps({
  messageType: { type: String, required: true },
  messages: { type: Array, required: true }
})

const displayedMessages = computed(() => {
  const filterMessages = filter(props.messages, (message: Message) => {
    if (message.type === props.messageType) {
      return message
    }
  })
  return sortBy(filterMessages, 'createdAt') as Message[]
})

</script>
